
import React from "react";

import {polyfill} from "mobile-drag-drop";
import {scrollBehaviourDragImageTranslateOverride} from "mobile-drag-drop/scroll-behaviour";

polyfill({
    dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride,
    tryFindDraggableTarget: event => event.target.id == 'drg' ? event.target : undefined
});

   
const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17/bundles/games/dist";

class BlockPuzzle extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            iddraggable:0,
            iddroppable:0,
            listGame : [0, 1, 2, 3, 4,5,6,7,8,9,10,11,12],
            mapWin : [],
            win:false,
            listGameObj:[
                  //src={ASSETS_BASE + "/images/time.png"}
              //  ASSETS_BASE + "/images/dog_win.png"}
                /*{ id:0, val:'1' ,   src: ASSETS_BASE + '/images/images_puzzle/Puzzle_img_01.png'   ,hovercls:false  },
                { id:1, val:'2' ,   src:ASSETS_BASE + '/images/images_puzzle/Puzzle_img_02.png' ,hovercls:false },
                { id:2, val:'3' ,   src:ASSETS_BASE + '/images/images_puzzle/Puzzle_img_03.png' ,hovercls:false },
                { id:3, val:'4' ,   src:ASSETS_BASE + '/images/images_puzzle/Puzzle_img_04.png' ,hovercls:false },
                { id:4, val:'5' ,   src:ASSETS_BASE + '/images/images_puzzle/Puzzle_img_05.png' ,hovercls:false},
                { id:5, val:'6' ,   src:ASSETS_BASE + '/images/images_puzzle/Puzzle_img_06.png' ,hovercls:false},
                { id:6, val:'7' ,   src:ASSETS_BASE + '/images/images_puzzle/Puzzle_img_07.png' ,hovercls:false},
                { id:7, val:'8' ,   src:ASSETS_BASE + '/images/images_puzzle/Puzzle_img_08.png' ,hovercls:false},
                { id:8, val:'9' ,   src:ASSETS_BASE +'/images/images_puzzle/Puzzle_img_09.png' ,hovercls:false},
                { id:9, val:'10' ,  src:ASSETS_BASE + '/images/images_puzzle/Puzzle_img_10.png' ,hovercls:false},
                { id:10, val:'11' , src:ASSETS_BASE +'/images/images_puzzle/Puzzle_img_11.png' ,hovercls:false},
                { id:11, val:'12' , src:ASSETS_BASE +'/images/images_puzzle/Puzzle_img_12.png' ,hovercls:false},
                { id:12, val:'13' , src:ASSETS_BASE +'/images/images_puzzle/Puzzle_img_13.png' ,hovercls:false},
                { id:13, val:'14' , src:ASSETS_BASE +'/images/images_puzzle/Puzzle_img_14.png' ,hovercls:false},
                { id:14, val:'15' , src:ASSETS_BASE +'/images/images_puzzle/Puzzle_img_15.png' ,hovercls:false},
                { id:15, val:'16' , src:ASSETS_BASE +'/images/images_puzzle/Puzzle_img_16.png'  ,hovercls:false}*/
                /* PUZZLE 2  */
                { id:0, val:'1' ,   src: ASSETS_BASE + '/images/images_puzzle_2/Puzzle_img_2_01.png' ,hovercls:false  },
                { id:1, val:'2' ,   src:ASSETS_BASE + '/images/images_puzzle_2/Puzzle_img_2_02.png' ,hovercls:false },
                { id:2, val:'3' ,   src:ASSETS_BASE + '/images/images_puzzle_2/Puzzle_img_2_03.png' ,hovercls:false },
                { id:3, val:'4' ,   src:ASSETS_BASE + '/images/images_puzzle_2/Puzzle_img_2_04.png' ,hovercls:false },
                { id:4, val:'5' ,   src:ASSETS_BASE + '/images/images_puzzle_2/Puzzle_img_2_05.png' ,hovercls:false},
                { id:5, val:'6' ,   src:ASSETS_BASE + '/images/images_puzzle_2/Puzzle_img_2_06.png' ,hovercls:false},
                { id:6, val:'7' ,   src:ASSETS_BASE + '/images/images_puzzle_2/Puzzle_img_2_07.png' ,hovercls:false},
                { id:7, val:'8' ,   src:ASSETS_BASE + '/images/images_puzzle_2/Puzzle_img_2_08.png' ,hovercls:false},
                { id:8, val:'9' ,   src:ASSETS_BASE +'/images/images_puzzle_2/Puzzle_img_2_09.png' ,hovercls:false},
                { id:9, val:'10' ,  src:ASSETS_BASE + '/images/images_puzzle_2/Puzzle_img_2_10.png' ,hovercls:false},
                { id:10, val:'11' , src:ASSETS_BASE +'/images/images_puzzle_2/Puzzle_img_2_11.png' ,hovercls:false},
                { id:11, val:'12' , src:ASSETS_BASE +'/images/images_puzzle_2/Puzzle_img_2_12.png' ,hovercls:false},
                { id:12, val:'13' , src:ASSETS_BASE +'/images/images_puzzle_2/Puzzle_img_2_13.png' ,hovercls:false},
                { id:13, val:'14' , src:ASSETS_BASE +'/images/images_puzzle_2/Puzzle_img_2_14.png' ,hovercls:false},
                { id:14, val:'15' , src:ASSETS_BASE +'/images/images_puzzle_2/Puzzle_img_2_15.png' ,hovercls:false},
                { id:15, val:'16' , src:ASSETS_BASE +'/images/images_puzzle_2/Puzzle_img_2_16.png'  ,hovercls:false}
                /* PUZZLE 2  */
            ],
            indexSwitch:[0,0],
            secondIndex:9999,
            firstIndex: 9999,
            classHover: false
        }

        this._OnDrag          = this._OnDrag.bind(this);
        this._OnDragOver      = this._OnDragOver.bind(this);
        this._onDragLeave     = this._onDragLeave.bind(this);
        this._OnDragStartDrag = this._OnDragStartDrag.bind(this);
        this._OnDragOverDrag  = this._OnDragOverDrag.bind(this);
        this._OnDropCapture   = this._OnDropCapture.bind(this);
        this._OnDragEndDrag   = this._OnDragEndDrag.bind(this);
        this.getIndexDnD      = this.getIndexDnD.bind(this);
        this._onDragEndCapture = this._onDragEndCapture.bind(this)
        this.checkSwitchElement = this.checkSwitchElement.bind(this)

        this.getIndexArrOBJ  = this.getIndexArrOBJ.bind(this)
        this.swapElement   = this.swapElement.bind(this)
        this.shuffleGame   = this.shuffleGame.bind(this)
        this.checkWin   = this.checkWin.bind(this)
        this.renderWinBlock = this.renderWinBlock.bind(this)
        this.chageElement = this.chageElement.bind(this)

    }

    componentDidMount() {

        this.shuffleGame();

        let mapWinUpdate = [];
        let mapWinUpdateLength = this.state.listGameObj.length;


        for( let i=0; i<mapWinUpdateLength; i++ ){
            mapWinUpdate.push(i);
        }
        this.setState(
            { mapWin:[...mapWinUpdate] }
        )

    }

    shuffleGame() {
        this.setState(
            {  listGameObj : [...this.state.listGameObj.sort( () => Math.random() - 0.5)]  }
        )
    }


    checkWin(){
        let tempArray = [];
        this.state.listGameObj.map( (item) => {
            tempArray.push( parseInt(item.id) );

        });


        console.log( tempArray, this.state.mapWin )
        // this.state.mapWin  ===  tempArray
        if( JSON.stringify(this.state.mapWin) === JSON.stringify(tempArray)  ) {

            this.setState({
                win:true
            })
            //cambio elemento -> trigger mywin function
            this.chageElement()
        }
    }

    //Metodo di soluzione mywin() passato da puzzleGame.js come props
    chageElement(){
        this.props.mywin()
    }


    getIndexDnD(toEle,prop,value){
        const isLargeNumber = (element) => element == toEle;
        //  console.log( 'INDEX: BY ' + [toEle] , parseInt( this.state.listGame.findIndex(isLargeNumber) ) );
        let dnxd = parseInt( this.state.listGameObj.findIndex(isLargeNumber) );
        //let indexObj = this.getIndexArrOBJ('15', this.state.listGameObj , 'val')
        return dnxd;
    }
    getIndexArrOBJ(value , arr, prop){
        //var index = getIndex('one', skillsets, 'id');
        for(var i = 0; i < arr.length; i++) {
            if(arr[i][prop] === value) {
                return i;
            }
        }
        return -1;
    }
    _OnDrag(e) {  e.preventDefault()  }
    _OnDragOver(e) {
        e.preventDefault()
        e.target.style.background = "#dddddd";
        let numInital = e.target.getAttribute('custom-attribute');
        //  console.log('_OnDragOver ELEMENT SEC', numInital);
        this.setState({
            iddroppable: e.target.getAttribute('custom-attribute')
        })
        debugger;
    }
    _onDragLeave(e) {  
          //console.log('Leave drag')
          e.target.classList.remove('people')
       }


    _OnDragStartDrag(e) {

        this.setState({
            iddraggable: e.target.getAttribute('custom-attribute')
        })
        //console.log('_OnDragStartDrag');

    }

    _OnDragOverDrag(e) {
        e.target.style.color = "red";
    }

    _OnDragEndDrag(e) {
        /*  e.target.className = "";
          e.target.className = "myactive";*/
          
        this.setState({
            iddraggable: e.target.getAttribute('custom-attribute')
        })
    }
    _OnDropCapture(e) {

        let numCard = e.target.getAttribute('custom-attribute');

        this.setState({
            iddroppable:  numCard ,
            // firstIndex : this.getIndexDnD(parseInt(numCard))
            firstIndex : this.getIndexArrOBJ(numCard, this.state.listGameObj ,'val')
        })
        this.getIndexDnD( numCard )
    }
    _onDragEndCapture(e) {
        e.preventDefault();
        e.stopPropagation();
        //e.target.classList.remove('people')
        let numCard = e.target.getAttribute('custom-attribute');

        let idx = this.getIndexDnD( parseInt(numCard) );

        this.setState({
            secondIndex : this.getIndexArrOBJ(numCard ,this.state.listGameObj,'val'),
            iddraggable : e.target.getAttribute('custom-attribute')
        },()=> {
            this.swapElement()
            this.checkWin()
        });
        //console.log('_onDragEndCapture')
    }

    // swap tra elemento dragged  / elemento dropped dropped
    swapElement(){

        if(  this.state.secondIndex != 9999  &&   this.state.firstIndex != 9999  ) {


            let copyArray = this.state.listGameObj;

            if(  this.state.firstIndex !== this.state.secondIndex  ) {
                let current = copyArray[this.state.firstIndex];
                copyArray[this.state.firstIndex]  = copyArray[this.state.secondIndex];
                copyArray[this.state.secondIndex] = current;

                this.setState(
                    {
                        secondIndex:9999,
                        firstIndex: 9999,
                        listGameObj :[...copyArray]    }
                )
            } else {
                this.setState(
                    {
                        secondIndex:9999,
                        firstIndex: 9999
                    }
                )  }
        } else{
            console.log("NOT TWO ELEMENT SELECTED")
            this.setState(
                {
                    secondIndex:9999,
                    firstIndex: 9999
                }
            )
        }

    }

    //REMOVE ELEMENT BY INDEX
    checkSwitchElement(e , numCard ) {
        var array = this.state.listGame;
        var index = array.indexOf(numCard); // Let's say it's Bob.
        delete array[index];
    }

    renderWinBlock() {
        return (
            <p>Complimenti hai Vinto!</p>
        )
    }


    render() {
        return (


            <div className={'container-style'}>
                {
                    this.state.listGameObj.map( (item, index) =>
                        <div key={item.id}

                             style={{  backgroundImage: "url("+ item.src +")"   } }
                            // style={ backgroundImage : "url('https://i.picsum.photos/id/71/200/200.jpg?hmac=TxuNm2jDRRNlSKPRxG7HH5vT63Bl20fD7M81shzv45M')" }
                             id="drg"

                             custom-attribute={ item.val }
                             onDragStart={ (e) => {
                                 e.target.classList.add('people')
                                 console.log( ' onDragStart'  )
                                 this.setState({  classHover: true })
                                }
                             }
                             onDragEnd={ this._OnDragEndDrag }
                             onDragEndCapture={ this._onDragEndCapture }
                             onDragOver={ (e) => {
                                 // e.target.style.border = '2px solid red'
                                 console.log('onDragOver')
                             } }
                             onDropCapture = { (e)=>{ console.log(e.target) } }
                             onDragEnter={ this._OnDropCapture }
                             onDragLeave={ this._onDragLeave   }

                             onDropCapture={ (e)=>console.log(e.target) }
                             draggable={"true"}
                        ></div>
                    )
                }

                  {/*  <div id={'itercept'}>

                    <p>status Winner: { this.state.win ? "WINNER" : "LOSE"}</p>
                        <p> FIRST INDEX: { this.state.firstIndex } SECOND INDEX:   { this.state.secondIndex } </p>
                        <p> ID_DRAGGABLE:  { this.state.iddraggable }    </p>
                        <p> ID_DROPPABLE: { this.state.iddroppable }     </p>
                    </div>*/}
            </div>
        );
    }
}



export default BlockPuzzle
